import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ThermostatDisplayBox } from './components';
import './ThermostatsDisplay.css';

export class ThermostatsDisplay extends Component {
  // maps the list of thermostats to the display boxes

  groupByFloor = () => {
    const { filteredThermostats } = this.props;
    const groupByFloor = filteredThermostats.reduce((acc, obj) => {
      const key = obj.floor_number;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
    return groupByFloor;
  };

  renderThermostatGroup(array) {
    const {
      graphDateRange: { value },
      selectedBuilding: { slug },
    } = this.props;

    return (
      <React.Fragment>
        {array.map((thermostat) => {
          const {
            uid_hash: id,
            ambient_temperature: ambientTemperature,
            mode,
            fan_mode: fanMode,
            target_temperature: targetTemperature,
            state,
            is_fan_running: isFanRunning,
            is_occupied: isOccupied,
            connection_state: connectionState,
            display_name: displayName,
          } = thermostat;
          return (
            <Link
              to={`/${slug}/thermostats/suite-graphs?uid=${id}&filter=${value}`}
              key={id}
              className="thermostats-display-item"
            >
              <ThermostatDisplayBox
                ambientTemperature={ambientTemperature}
                fanMode={fanMode}
                mode={mode}
                targetTemperature={targetTemperature}
                state={state}
                isFanRunning={isFanRunning}
                isOccupied={isOccupied}
                connectionState={connectionState}
                displayName={displayName}
              />
            </Link>
          );
        })}
      </React.Fragment>
    );
  }

  render() {
    const groupedThermostats = this.groupByFloor();
    const keys = Object.keys(groupedThermostats);
    return (
      <div className="thermostats-display-list">
        {keys.map((key) => (
          <div key={key} className="thermostats-display-list__group">
            {this.renderThermostatGroup(groupedThermostats[key])}
          </div>
        ))}
      </div>
    );
  }
}

/* eslint-disable react/forbid-prop-types */
ThermostatsDisplay.propTypes = { filteredThermostats: PropTypes.array };
/* eslint-enable react/forbid-prop-types */

ThermostatsDisplay.defaultProps = { filteredThermostats: [] };

function mapStateToProps(state) {
  return {
    filteredThermostats: state.thermostatReducer.filteredThermostats,
    selectedBuilding: state.buildingReducer.selectedBuilding,
    graphDateRange: state.suiteReducer.graphDateRange,
  };
}

const ConnectedThermostatsDisplay = connect(mapStateToProps)(ThermostatsDisplay);
export { ConnectedThermostatsDisplay };
